import request from '@/axios'

export function getTableLimit (payload) {
  return request({
    url: '/table_setting/get',
    method: 'POST',
    data: payload
  })
}

export function setTableLimit (payload) {
  return request({
    url: '/table_setting/update',
    method: 'POST',
    data: payload
  })
}